import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCalendarDay,
  faWindowMaximize,
  faWindowRestore,
  faCalendarTimes,
  faCalendarPlus,
  faClone
} from '@fortawesome/pro-regular-svg-icons';
import {
  faFile,
  faFileChartLine,
  faChartNetwork,
  faFlask,
  faFileInvoice,
  faFileSearch,
  faFileSignature,
  faFileInvoiceDollar,
  faCopy,
  faLightbulbOn,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faInfoCircle,
  faQuestionCircle,
  faCheck, 
  faCheckCircle,
  faTimes,
  faTimesCircle,
  faPlus,
  faPlusSquare,
  faTrashAlt,
  faSave,
  faPencilAlt,
  faSearch,
  faSyncAlt,
  faHistory,
  faRedoAlt,
  faUndoAlt,
  faAngleRight,
  faAngleDown,
  faArrowUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faColumns,
  faChartPie,
  faTable,
  faBars,
  faSignOut,
  faStickyNote,
  faCommentAltDots, 
  faLock,
  faTools, 
  faEnvelope
} from '@fortawesome/pro-solid-svg-icons';


export const StickyNote = ({ title, className }) => (
  <FontAwesomeIcon icon={faStickyNote} className={className} />
);

export const FasFile = ({ title, className }) => (
  <FontAwesomeIcon icon={faFile} className={className} />
);

export const FasFileChartLine = ({ title, className }) => ( // protocol details
  <FontAwesomeIcon icon={faFileChartLine} className={className} />
);

export const FasChartNetwork = ({ title, className }) => ( // participation
  <FontAwesomeIcon icon={faChartNetwork} className={className} />
);

export const FasFlask = ({ title, className }) => ( // study agents
  <FontAwesomeIcon icon={faFlask} className={className} />
);

export const FasFileInvoice = ({ title, className }) => ( // PSRs
  <FontAwesomeIcon icon={faFileInvoice} className={className} />
);

export const FasFileSignature = ({ title, className }) => ( // Submit with signature
  <FontAwesomeIcon icon={faFileSignature} className={className} />
);

export const FasFileSearch = ({ title, className }) => ( // CIRB
  <FontAwesomeIcon icon={faFileSearch} className={className} />
);

export const FasFileInvoiceDollar = ({ title, className }) => ( // funding
  <FontAwesomeIcon icon={faFileInvoiceDollar} className={className} />
);

export const FasCopy = ({ title, className }) => ( // documents
  <FontAwesomeIcon icon={faCopy} className={className} />
);

export const FarClone = ({ title, className }) => (
  <FontAwesomeIcon icon={faClone} className={className} />
);

export const FasLightbulbOn = ({ title, className }) => ( // insights
  <FontAwesomeIcon icon={faLightbulbOn} className={className} />
);

export function CalenderIcon(props) {
  return (
    <SvgIcon {...props} color="primary">
      <path d="M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z" />
    </SvgIcon>
  );
}

export const FarCalendarDay = ({ title, className }) => (
  <FontAwesomeIcon icon={faCalendarDay} className={className} />
);

export const FarCalendarTimes = ({ title, className }) => (
  <FontAwesomeIcon icon={faCalendarTimes} style={{ fontSize: '20px' }} className={className} />
);

export const FarCalendarPlus = ({ title, className }) => (
  <FontAwesomeIcon icon={faCalendarPlus} style={{ fontSize: '20px' }} className={className} />
);

export function Exclamation(props) {
  return (
    <SvgIcon {...props} color="error">
      <path d="M11,4.5H13V15.5H11V4.5M13,17.5V19.5H11V17.5H13Z" />
    </SvgIcon>
  );
}

export const FasExclamation = ({ title, className }) => (
  <FontAwesomeIcon icon={faExclamation} className={className} />
);

export const FasExclamationCircle = ({ title, className }) => (
  <FontAwesomeIcon icon={faExclamationCircle} className={className} />
);

export const FasExclamationTriangle = ({ title, className }) => (
  <FontAwesomeIcon icon={faExclamationTriangle} className={className} />
);

export const FasInfoCircle = ({ title, className }) => (
  <FontAwesomeIcon icon={faInfoCircle} className={className} />
);

export const FasQuestionCircle = ({ title, className }) => (
  <FontAwesomeIcon icon={faQuestionCircle} className={className} />
);

export const FarQuestionCircle = ({ title, className }) => (
  <svg
    aria-hidden={title ? 'false' : 'true'}
    focusable="false"
    data-prefix="far"
    data-icon="question-circle"
    className={`svg-inline--fa fa-exclamation-circle ${className}`}
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
  >
    {title && <title>{title}</title>}
    <path
      fill="currentColor"
      d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm107.244-255.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C184.846 131.491 214.94 112 261.794 112c49.071 0 101.45 38.304 101.45 88.8zM298 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z"
    />
  </svg>
);

export const FasCheck = ({ title, className }) => (
  <FontAwesomeIcon icon={faCheck} className={className} />
);

export const FasCheckCircle = ({ title, className }) => (
  <FontAwesomeIcon icon={faCheckCircle} className={className} />
);

export const FasTimes = ({ title, className }) => ( // close
  <FontAwesomeIcon icon={faTimes} className={className} />
);

export const FasTimesCircle = ({ title, className }) => ( // cancel
  <FontAwesomeIcon icon={faTimesCircle} className={className} />
);

export const FasPlus = ({ title, className }) => ( // add, new
  <FontAwesomeIcon icon={faPlus} className={className} />
);

export const FasPlusSquare = ({ title, className }) => ( // unique add
  <FontAwesomeIcon icon={faPlusSquare} className={className} />
);

export const FasTrashAlt = ({ title, className }) => ( // delete
  <FontAwesomeIcon icon={faTrashAlt} className={className} />
);

export const FasSave = ({ title, className }) => ( // save
  <FontAwesomeIcon icon={faSave} className={className} />
);

export const FasPencilAlt = ({ title, className }) => ( // edit
  <FontAwesomeIcon icon={faPencilAlt} className={className} />
);

export const FasSearch = ({ title, className }) => (
  <FontAwesomeIcon icon={faSearch} className={className} />
);

export const FasSyncAlt = ({ className }) => ( // sync, refresh, update
  <FontAwesomeIcon icon={faSyncAlt} className={className} />
);

export const FasHistory = ({ title, className }) => ( // history
  <FontAwesomeIcon icon={faHistory} className={className} />
);

export const FasRedoAlt = ({ title, className }) => ( // redo
  <FontAwesomeIcon icon={faRedoAlt} className={className} />
);

export const FasUndoAlt = ({ title, className }) => ( // undo, clear changes, reset
  <FontAwesomeIcon icon={faUndoAlt} className={className} />
);

export const FasAngleRight = ({ title, className }) => ( // collapsed, next, right
  <FontAwesomeIcon icon={faAngleRight} className={className} />
);

export const FasAngleDown = ({ title, className }) => ( // expanded, down
  <FontAwesomeIcon icon={faAngleDown} className={className} />
);

export const FasArrowUp = ({ title, className }) => ( // up
  <FontAwesomeIcon icon={faArrowUp} className={className} />
);

export const FasArrowDown = ({ title, className }) => ( // down
  <FontAwesomeIcon icon={faArrowDown} className={className} />
);

export const FasArrowLeft = ({ title, className }) => ( // left
  <FontAwesomeIcon icon={faArrowLeft} className={className} />
);

export const FasArrowRight = ({ title, className }) => ( // right
  <FontAwesomeIcon icon={faArrowRight} className={className} />
);

export const FarWindowRestore = ({ title, className }) => (
  <FontAwesomeIcon icon={faWindowRestore} className={className} />
);

export const FarWindowMaximize = ({ title, className }) => ( // single screen
  <FontAwesomeIcon icon={faWindowMaximize} className={className} />
);

export const FasColumns = ({ title, className }) => ( // splitscreen
  <FontAwesomeIcon icon={faColumns} className={className} />
);

export const FasTable = ({ title, className }) => (
  <FontAwesomeIcon icon={faTable} className={className} />
);

export const FasChartPie = ({ title, className }) => (
  <FontAwesomeIcon icon={faChartPie} className={className} />
);

export const FasBars = ({ title, className }) => ( // hamburger menu
  <FontAwesomeIcon icon={faBars} className={className} />
);

export const FasSignOut = ({ title, className }) => (
  <FontAwesomeIcon icon={faSignOut} className={className} />
);

export const FasCommentAltDots = ({ title, className }) => (
  <FontAwesomeIcon icon={faCommentAltDots} className={className} />
);

export const FasLock = ({ title, className }) => ( // https://jira.westat.com/browse/RSSMOD-905
  <FontAwesomeIcon icon={faLock} className={className} />
);

export const FasTools = ({ title, className }) => ( // https://jira.westat.com/browse/RSSMOD-906
  <FontAwesomeIcon icon={faTools} className={className} />
);

export const FasEnvelope = ({ title, className }) => (
  <FontAwesomeIcon icon={faEnvelope} className={className} />
);

export const FasSignIn = ({ title, className }) => (
  <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="sign-in" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className={`svg-inline--fa fa-sign-in ${className}`} style={{ height: '1.5rem', width: '1.5rem' }}>
    <path fill="currentColor" d="M137.2 110.3l21.9-21.9c9.3-9.3 24.5-9.4 33.9-.1L344.9 239c9.5 9.4 9.5 24.7 0 34.1L193 423.7c-9.4 9.3-24.5 9.3-33.9-.1l-21.9-21.9c-9.7-9.7-9.3-25.4 .8-34.7l77.6-71.1H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h191.5l-77.6-71.1c-10-9.1-10.4-24.9-.7-34.5zM512 352V160c0-53-43-96-96-96h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h84c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h84c53 0 96-43 96-96z"></path>
  </svg>
)

// export const FasXXX = ({ title, className }) => (
//   <FontAwesomeIcon icon={faXXX} className={className} />
// );